import React from 'react';
import { Modal } from '@gamma/ui/overlay';
import { CTAButton } from '@gamma/ui/buttons';
import { Text } from '@chakra-ui/react';
import { i18n } from '@investigator/shared/localization';

const { systemUseNotification, systemUseNotificationTitle } = i18n.app;

interface SystemUseBannerProps {
  isOpen: boolean;
  onAcknowledge: () => void;
}

export const SystemUseBanner: React.FC<SystemUseBannerProps> = ({
  isOpen,
  onAcknowledge,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        /* intentionally empty: force user to acknowledge */
      }}
      isCloseHidden={true}
      isCentered
      hideDivider
      size="sm"
      title={systemUseNotificationTitle}
      body={<Text>{systemUseNotification}</Text>}
      footer={
        <CTAButton colorScheme="blue" onClick={onAcknowledge} autoFocus>
          I Acknowledge
        </CTAButton>
      }
    />
  );
};
